import { Flex, Grid, GridItem } from '@sequencehq/core-components'
import { ReactNode } from 'react'
import {
  CountryFilterControl,
  IntegrationCustomerFilterBar
} from './IntegrationCustomerFilterBar'
import { CustomerEmptyStateAction } from './IntegrationCustomerEmptyState'
import {
  IntegrationCustomerList,
  SelectAllControl
} from './IntegrationCustomerList'
import { SelectableCustomer } from './integrationCustomer.types'

export const IntegrationCustomerPicker = (props: {
  action: CustomerEmptyStateAction
  customers: SelectableCustomer[]
  heading?: string
  subHeaderInfo?: ReactNode
  search: string
  onSearchChange: (value: string) => void
  countryFilter?: CountryFilterControl
  onClearFilters: () => void
  hasActiveFilters: boolean
  selectedCustomerIds: string[]
  onToggleCustomer: (id: string) => void
  selectAll?: SelectAllControl
  blockInvalidSelection?: boolean
  integrationName?: string | null
  unfilteredCustomerCount: number
  allCustomersLinked: boolean
  height?: string
  'data-testid': string
}) => (
  <Grid
    gridTemplateRows="auto minmax(0, 1fr)"
    gridTemplateColumns="minmax(0, 1fr)"
    height={props.height ?? '100%'}
    width="100%"
    alignContent="start"
    data-testid={props['data-testid']}
  >
    <GridItem>
      <IntegrationCustomerFilterBar
        heading={props.heading}
        subHeaderInfo={props.subHeaderInfo}
        search={props.search}
        onSearchChange={props.onSearchChange}
        countryFilter={props.countryFilter}
        data-testid={props['data-testid']}
      />
    </GridItem>
    <GridItem minHeight={0}>
      <Flex height="100%" width="100%">
        <IntegrationCustomerList
          action={props.action}
          customers={props.customers}
          search={props.search}
          selectedCustomerIds={props.selectedCustomerIds}
          onToggleCustomer={props.onToggleCustomer}
          blockInvalidSelection={props.blockInvalidSelection ?? true}
          integrationName={props.integrationName}
          hasActiveFilters={props.hasActiveFilters}
          onClearFilters={props.onClearFilters}
          unfilteredCustomerCount={props.unfilteredCustomerCount}
          allCustomersLinked={props.allCustomersLinked}
          selectAll={props.selectAll}
          data-testid={props['data-testid']}
        />
      </Flex>
    </GridItem>
  </Grid>
)
